import * as style from './style.module.css';

const UsersGrid = ({ children, center, className = '' }) => (
  <div className={`${style.container} ${center ? style.center : ''} ${className}`}>{children}</div>
);

export default UsersGrid;
